"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsultanciesService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class ConsultanciesService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'consultancies';
        this.getMeetingTimes = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/meetingtime`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateConsultancy = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCreateMeetTeams = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/meetingactions`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProfilePicUsers = async (email) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/profilepics/${email}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getConsultancyByPerson = async (person_id, type, fecha) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}?person_id=${person_id}&type=${type}&fecha=${fecha}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postModifyConsultancy = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/modify`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAdvisers = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/advisers`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAdvisersLimits = async (page, size, filter) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/advisers/pagination?page=${page}&size=${size}&filter=${filter}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postSetCalificationsConsultancies = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/califications`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProfileAdviser = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/advisers/${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getHistoryConsultancies = async (req) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/advisers`;
            const response = await axios_1.default.post(URL, JSON.stringify(req), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.ConsultanciesService = ConsultanciesService;
